export function getAvailableYears(currentYear: number, pastYearLimit: number) {
  const defaultYearOptions = Array.from(
    { length: pastYearLimit },
    (_, index) => currentYear - index,
  );
  const mergedYears = [...new Set([currentYear, ...defaultYearOptions])].sort((a, b) => b - a);

  return mergedYears;
}
